export const apiUrl = "https://a.zhongshe.cc";
// export const apiUrl = "https://miniapp.static.zhongsheyun.com";
